import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FlaskConical } from "lucide-react"; // ✅ lab icon
import axios from "axios";
import Navbar from "./Navbar";

const LabSummaryNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [labSummary, setLabSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchLabSummary = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/lab_summary", // ✅ API for lab summary
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setLabSummary(response.data.summary);
      }
    } catch (error) {
      console.error("Error fetching lab summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLabSummary();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-red-100">
      <Navbar />

      {/* Main Container */}
      <div className="flex justify-center items-start px-4 sm:px-6 md:px-8 pt-28 pb-12">
        <div className="w-full max-w-3xl bg-white rounded-3xl shadow-xl border border-pink-100 p-6 sm:p-10 transition-all">

          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-pink-100 p-3 rounded-full shadow-md">
              <FlaskConical className="w-7 h-7 sm:w-9 sm:h-9 text-pink-600" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-semibold text-pink-800">
              Lab Summary Note
            </h1>
          </div>

          {/* Lab Summary */}
          {isLoading ? (
            <div className="text-center text-pink-600 font-medium text-lg">
              Loading lab summary...
            </div>
          ) : !labSummary ? (
            <div className="text-center text-gray-600 font-medium text-lg">
              No lab summary found for this patient.
            </div>
          ) : (
            <div className="space-y-4">
              <div
                className="relative bg-gradient-to-br from-white/80 to-pink-50/70 backdrop-blur-md text-gray-800 p-5 sm:p-7 rounded-2xl text-base sm:text-lg border border-pink-200 shadow-md hover:shadow-lg transition-all duration-300"
              >
                <p className="italic text-gray-600">
                  Notes: {labSummary || "No notes"}
                </p>
              </div>
            </div>
          )}

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto bg-gradient-to-r from-pink-500 to-red-600 hover:from-pink-600 hover:to-red-700 text-white font-semibold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabSummaryNote;

